import { render } from "./BasePagination.vue?vue&type=template&id=64e21f6a&scoped=true"
import script from "./BasePagination.vue?vue&type=script&lang=js"
export * from "./BasePagination.vue?vue&type=script&lang=js"

import "./BasePagination.vue?vue&type=style&index=0&id=64e21f6a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e21f6a"]])

export default __exports__